import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'
import MenuButton from '../../MenuButton.jsx'

export default function MenuButtonAiGenerateFa(props) {
    const map = useMapContext()
    const {mapTypeCode} = map.data

    if ('_FA_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = () => {
        const {pkid, prjId, sVer} = map.root.data

        openWindow(
            '/Ai',

            {
                dpIds: [pkid],
                prjId,
                scene: 'GENERATE_FA',
                sVer,
            }
        )
    }

    return (
        <MenuButton
            onClick={onClick}
            {...props}
        >
            AI建模
        </MenuButton>
    )
}
